document.addEventListener("DOMContentLoaded", function (event) {
  const ovzSliderData = [
    {
      webpUrl: "../img/ovz/1.webp 1x, ../img/ovz/1@2x.webp 2x",
      imgUrl: "../img/ovz/1.jpg",
      img2xUrl: "../img/ovz/1@2x.jpg 2x",
      alt: "Кабинет инклюзивного обучения",
    },
    {
      webpUrl: "../img/ovz/2.webp 1x, ../img/ovz/2@2x.webp 2x",
      imgUrl: "../img/ovz/2.jpg",
      img2xUrl: "../img/ovz/2@2x.jpg 2x",
      alt: "Компьютер, адаптированный для работы слабослышащим пользователем",
    },
    {
      webpUrl: "../img/ovz/3.webp 1x, ../img/ovz/3@2x.webp 2x",
      imgUrl: "../img/ovz/3.jpg",
      img2xUrl: "../img/ovz/3@2x.jpg 2x",
      alt: "Для инвалидов-колясочников организован доступ в филиал через расширенный проем, оборудован пандус, система вызова персонала",
    },
    {
      webpUrl: "../img/ovz/4.webp 1x, ../img/ovz/4@2x.webp 2x",
      imgUrl: "../img/ovz/4.jpg",
      img2xUrl: "../img/ovz/4@2x.jpg 2x",
      alt: "Парковочное место для инвалидов",
    },
    {
      webpUrl: "../img/ovz/5.webp 1x, ../img/ovz/5@2x.webp 2x",
      imgUrl: "../img/ovz/5.jpg",
      img2xUrl: "../img/ovz/5@2x.jpg 2x",
      alt: "Туалетная комната оборудована удобными поручнями, системой вызова персонала, расширенным дверным проемом, специальной дверью",
    },
  ];
  const ovzSlider = document.querySelector(".ovz-slider");
  const viewport = ovzSlider.querySelector(".ovz-slider__viewport");
  const pictureWebp = viewport.children[0].children[0];
  const pictureJpeg = viewport.children[0].children[1];
  const text = ovzSlider.querySelector(".ovz-slider__text");
  const prev = ovzSlider.querySelector(".ovz-slider__prev");
  const next = ovzSlider.querySelector(".ovz-slider__next");
  const currentNumber = ovzSlider.querySelector(".ovz-slider__current-number");
  const allNumbers = ovzSlider.querySelector(".ovz-slider__all-numbers");
  let currentSlide = 0;

  function updateSlider(index) {
    pictureWebp.setAttribute("srcset", ovzSliderData[index].webpUrl);
    pictureJpeg.setAttribute("src", ovzSliderData[index].imgUrl);
    pictureJpeg.setAttribute("srcset", ovzSliderData[index].img2xUrl);
    pictureJpeg.setAttribute("alt", ovzSliderData[index].alt);

    text.innerHTML = ovzSliderData[index].alt;

    currentNumber.innerHTML = currentSlide + 1;
    allNumbers.innerHTML = ovzSliderData.length;
  }

  function prevSlide() {
    if (currentSlide === 0) {
      currentSlide = ovzSliderData.length - 1;
    } else {
      currentSlide--;
    }

    let tl = gsap.timeline();

    tl.to([viewport, text], {
      opacity: 0,
      duration: 0.5,
    })
      .call(updateSlider, [currentSlide])
      .to([viewport, text], {
        opacity: 1,
        duration: 0.5,
        delay: 0.1,
      });
  }

  function nextSlide() {
    if (currentSlide === ovzSliderData.length - 1) {
      currentSlide = 0;
    } else {
      currentSlide++;
    }

    let tl = gsap.timeline();
    tl.to([viewport, text], {
      opacity: 0,
      duration: 0.5,
    })
      .call(updateSlider, [currentSlide])
      .to([viewport, text], {
        opacity: 1,
        duration: 0.5,
        delay: 0.1,
      });
  }

  updateSlider(0);

  prev.addEventListener("click", (e) => {
    e.preventDefault();
    prevSlide();
  });
  next.addEventListener("click", (e) => {
    e.preventDefault();
    nextSlide();
  });
});
